import ArrowBottom from "assets/svg/arrow-bottom.svg";
import Play from "assets/svg/play.svg";
import React, { FC } from "react";

import { Title } from "..";
import style from "./styles.module.css";

type Props = {
  mentors: [
    {
      description: string;
      fullName: string;
      id: number;
      image: string;
    }
  ];
};

const Mentors: FC<Props> = ({ mentors }) => {
  return (
    <div
      className={`h-auto rounded bg-transparent py-5 transition-all`}
      style={{
        contain: "content",
      }}
    >
      <div className={`relative transition-all`} style={{ contain: "content" }}>
        <Title type="LINE" title="منتور های دادبانان" wrapperClass="mb-5" />
        <div className="grid w-full grid-cols-1 gap-x-5 gap-y-5 md:grid-cols-2">
          {mentors?.map(({ description, fullName, id, image }) => (
            <div
              key={JSON.stringify(id)}
              className="flex h-20 w-full overflow-hidden rounded border-b-2 border-l border-blue-550 bg-white"
            >
              <img
                loading="lazy"
                src={image ?? "images/nc-img.png"}
                className="h-full w-24 rounded-r"
                style={{
                  clipPath:
                    "polygon(34% 0, 100% 0, 100% 60%, 100% 100%, 0 100%, 0 100%, 17% 49%)",
                }}
                alt={fullName}
              />
              <div className="flex flex-col justify-evenly whitespace-nowrap px-1 text-black-450">
                <span className="text-sm">{fullName}</span>
                <span
                  className="text-[0.860rem]"
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Mentors;
